export default __webpack_public_path__ + "static/media/pigIcon.ad5c51d2.png";